<template>
  <vx-card>
    <div id="donut-generic" v-if="seriesData != null">

        <div id="title">
           <div v-if="infoButton">
            <label class="mr-1 clickable-icon" style="vertical-align:middle">{{ name }} </label> 
            <div class="tooltip" >
              <vs-icon class="clickable-icon" radius color="primary" type="flat" size="small" icon="helpcircle" style="opacity:0.6; vertical-align:middle" ></vs-icon>
              <span class="tooltiptext donut-tooltip" >{{infoButton}}</span>
            </div>
          </div>

          <div v-else>
            <label class=" mr-1" style="vertical-align:middle">{{ name }} </label> 
          </div>
        </div>

        <vue-apex-charts class="donutGraph" :height="heightModified" type="donut" :options="chartOptions" :series="series"></vue-apex-charts>
        
        <div class="donut-percentage" v-if="commercialOfferType=='SOCIALSECURITY' && percentageCategory == 'withoutCover'">
          <label class="label red-font">Ingresos sin cobertura </label>
          <label class="capital red-font">{{percentage.toFixed(0)}} %</label>
        </div>
        <div class="donut-percentage" v-if="commercialOfferType=='SOCIALSECURITY' && percentageCategory == 'withCover'">
          <label class="label blue-font">Cobertura sobre ingresos </label>
          <label class="capital blue-font">{{percentage.toFixed(0)}} %</label>
        </div>
    </div>
  </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import VueApexCharts from 'vue-apexcharts'

export default {
 props: {
    seriesData: Array,
    name: String,
    commercialOfferType: String,
    percentage: Number,
    infoButton: String,
    percentageCategory: String
  },

  components: { VxCard, VueApexCharts},

  data () {
    return {
      // percentage: 0,
      series: [],
      showInfo: false,
      heightModified: 350,
        
      chartOptions: {
        chart: {
          type: 'donut',
          width:'100%',
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 90,
            offsetY: 10,
            expandOnClick: false
          }
        },
        grid: {
          padding: {
            bottom: -120
          }
        },
        colors: ['#28C76F', 'rgba(var(--vs-secundary)', '#F34336', '#D500F9', '#18FFFF', '#FFFF00', '#FFA726'],
        themeColors: ['#28C76F', 'rgba(var(--vs-secundary)', '#F34336', '#D500F9', '#18FFFF', '#FFFF00', '#FFA726'],
        fill: {
          colors: ['#28C76F', 'rgba(var(--vs-secundary)', '#F34336', '#D500F9', '#18FFFF', '#FFFF00', '#FFA726']

        },
        dataLabels: {
          style: {
            fontSize: '14.5px',
            fontWeight: 'normal',
            colors: ['#FFFAF0', '#FFFAF0', '#FFFAF0']

          },
          enabled: true,
          formatter: function (val,opt,w) {
          return opt.w.globals.series[opt.seriesIndex].toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.") + ' €'
          }
        },
        legend: {
          show: false,
        },
        responsive: [{
          breakpoint: 380,
          chart: {
              width: '50%',
            },
            
          options: {
            
            // legend: {
            //   show: false,
            // }
          }
        }],
        tooltip: {
          enabled: false,
        }

      },

    }
  },

  created() {
      this.initValues()
     
  },
  methods:{
    initValues() {

      this.seriesData.forEach(value => {
          this.series.push(value)
        })
      
    },
    
    checkInfo(){
      if (this.showInfo == true) {
        this.showInfo = false
      } else {
        this.showInfo = true
      }
    }
  }
}
</script>

<style lang="scss">

#donut-generic {

  .tooltip .tooltiptext {
    bottom: 110%;
    padding: 1px 1px;
    margin-left: -115px;
    width: 185px;
  }

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-around;

  .donutGraph{
    overflow: visible !important;

    svg {
      overflow: visible !important;
    }
    
  }

  .red-font{
    color: rgba(var(--vs-danger), 1)
  }

  .blue-font{
    color: rgba(var(--vs-secundary), 1) !important;
  }
 
 .clickable-icon {
  color: rgba(var(--vs-secundary), 1) !important;
  } 
  // .tooltip .tooltiptext {
  // // To avoid it from hidding when mouse moves away - it is activated/deactivated by button
  // // not by mouse going over
  //   visibility: visible;
  // }


  @media screen and (max-width:299px) {
    .donutGraph {
      min-height: 100px !important;

      svg{
        transform: scale(0.6) !important;
        margin: auto;
        margin-top: -30px;
      }
      
    }

    .donut-percentage{
      width: 100%;
      margin: auto !important;
      padding-top: 120px;
      position: absolute;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;

      .label {
        font-size: 13px !important;
      }

      .capital{
        font-size:14px !important;
        font-weight:600;
      }

    }
  }
    
@media only screen and (min-width : 300px)
  and (max-width : 380px) {
    .donutGraph {
      svg{
        transform: scale(0.8);
        margin: auto;
      }
    }

    .donut-percentage{
        width: 20%;
        position: absolute;
        top: 52%;
        left: 40%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;

      .label {
        font-size: 13px !important;
      }

      .capital{
        font-size:14px !important;
        font-weight:600;
      }
    }

  }

  @media only screen and (min-width : 381px) {
    .donut-percentage{
      width: 20%;
      position: absolute;
      top: 52%;
      left: 40%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;

      .label {
          font-size: 14px !important;
        }

      .capital{
        font-size:20px !important;
        font-weight:600;
      }
    }

    // .donut-tooltip {

    //   position: absolute;
      
    //   z-index: 1;
    //   bottom: 150%;
    //   left: 0%;
    //   margin-left: -250px !important;
    // }
  }
    
}

</style>


